import { ILocalErrorsConfig, IRemoteErrorsConfig, RootErrorsConfig } from '@partners/errors';
export class ShellErrorsConfig extends RootErrorsConfig {
  override localErrors: ILocalErrorsConfig = {
    formatPrefix: `*****************`,
    formatSuffix: `*****************`,
    reportLog: false
  };
  override remoteErrors: IRemoteErrorsConfig = {
    client: {
      scope: {
        min: 400,
        max: 499
      }
    },
    server: {
      scope: {
        min: 500,
        max: 599
      }
    }
  };

  constructor() {
    super();
  }
}
